var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-iterator',{attrs:{"items":_vm.organizations,"row":"","wrap":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return [_c('v-row',_vm._l((items),function(item){return _c('v-col',{key:item.id,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('organization-card',{attrs:{"organization":item,"show":_vm.viewItem}})],1)}),1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }